import React from 'react';
import classnames from 'classnames';

export interface ListItemGraphicProps {
  className?: string;
  tabIndex?: number;
  graphic: React.ReactElement<any>;
  childrenTabIndex?: number;
}

const ListItemGraphic: React.FunctionComponent<ListItemGraphicProps> = ({
  tabIndex = -1,
  graphic,
  className = '',
  ...otherProps
}) => {
  const graphicProps = {
    className: classnames('mdc-list-item__graphic', className),
    tabIndex: tabIndex !== undefined ? tabIndex : -1,
    ...otherProps,
  };
  return React.cloneElement(graphic, graphicProps);
};

export default ListItemGraphic;
